// extracted by mini-css-extract-plugin
export default {"ineligible":"Eligibility_ineligible__QR39F","queryEligibility":"Eligibility_queryEligibility__ml1Jw"};